import { BuildingFeature } from '../types/types';
import { MapUpdater } from './MapUpdater';
import { MapContainer, TileLayer, GeoJSON } from 'react-leaflet';
import { useTheme } from '@mui/material/styles';

type AddressSearchMapProps = {
    mapBounds?: L.LatLngBounds;
    buildings?: BuildingFeature[];
    selectedBuilding?: BuildingFeature;
    onBuildingClick: (feature: BuildingFeature) => void;
};

const AddressSearchMap: React.FC<AddressSearchMapProps> = ({ onBuildingClick, mapBounds, buildings, selectedBuilding }) => {

  const { palette } = useTheme();

  return (
    <MapContainer
      center={[51.1657, 10.4515]} // Germany center
      zoom={6}
      maxZoom={19}
      scrollWheelZoom={true}
      style={{ height: '100%', width: '100%' }}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        maxZoom={19}
      />
      <MapUpdater bounds={mapBounds} />
      {buildings && buildings.map((feature) => (
        <GeoJSON
          key={feature.properties.identifier}
          data={feature}
          eventHandlers={{
            click: () => onBuildingClick(feature)
          }}
          style={() => ({
            color: feature.properties.identifier === selectedBuilding?.properties.identifier
              ? palette.secondary.main
              : palette.grey[600],
            weight: 2,
            fillOpacity: 0.5
          })}
        />
      ))}
    </MapContainer>
  );
};

export default AddressSearchMap;